import { redirect, Route } from "react-router-dom";
import DefaultRoute from "./default-route";
import PublicRoute from "./public-route";
import PrivateRoute from "./private-route";
import Login from "../pages/login/loginPage";
import Register from "../pages/register/register";
import Thanks from "../pages/register/Thanks";
import Dashboard from "../pages/dashboard/dashboard";
import Settings from "../pages/settings/settings";
import PageNotFound from "../pages/404/not-found-page";
import { EmailVerificationPage } from "../pages/email_verificiation/email-verification";
import { EmailVerificationSuccessPage } from "../pages/email_verificiation/email-verification-success";
import RegistrationMFASetupPage from "../pages/registration_mfa_setup/registration-mfa-setup";

import { MFAVerificationSuccessPage } from "../pages/registration_mfa_setup/registration-mfa-setup-success";

import MFALogin from "../pages/login/mfa-login-page";
import ForgotPasswordPage from "../pages/login/forgot-password-page";

//terms and privacy
import TermsPage from "../pages/privacy/terms";
import PrivacyPage from "../pages/privacy/privacy";

function PublicRoutes() {
  return [
    PublicRoute({ key: 1, path: "/login", attemptAutoLogin: false, element: <Login /> }),
    PublicRoute({ key: 2, path: "/mfa-login", attemptAutoLogin: false, element: <MFALogin /> }),
    PublicRoute({ key: 3, path: "/register", attemptAutoLogin: false, element: <Register /> }),
    PublicRoute({ key: 4, path: "/registration-success", attemptAutoLogin: false, element: <Thanks /> }),
    PublicRoute({ key: 5, path: "/email-verification", attemptAutoLogin: false, element: <EmailVerificationPage /> }),
    PublicRoute({ key: 6, path: "/email-verification-success", attemptAutoLogin: false, element: <EmailVerificationSuccessPage /> }),
    PublicRoute({ key: 7, path: "/mfa-setup", attemptAutoLogin: false, element: <RegistrationMFASetupPage /> }),
    PublicRoute({ key: 8, path: "/mfa-setup-success", attemptAutoLogin: false, element: <MFAVerificationSuccessPage /> }),
    PublicRoute({ key: 9, path: "/public/:userId", attemptAutoLogin: true, redirect: false, element: <Dashboard isPublicView={true} /> }),
    PublicRoute({ key: 10, path: "/public/:userId/:objectId", attemptAutoLogin: true, redirect: false, element: <Dashboard isPublicView={true} /> }),
    PublicRoute({ key: 11, path: "/forgot-password", attemptAutoLogin: false, redirect: false, element: <ForgotPasswordPage /> }),
    PublicRoute({ key: 12, path: "/terms", attemptAutoLogin: false, redirect: false, element: <TermsPage /> }),
    PublicRoute({ key: 13, path: "/privacy", attemptAutoLogin: false, redirect: false, element: <PrivacyPage /> }),
  ];
}

function PrivateRoutes() {
  return [
    PrivateRoute({ key: 7, path: "/dashboard", element: <Dashboard isPublicView={false} /> }),
    PrivateRoute({
      key: 8,
      path: "/dashboard/trash",
      element: <Dashboard key={window.location.pathname} dir="Trash" isTrash={true} isPublicView={false} />,
    }),
    PrivateRoute({ key: 9, path: "/settings", element: <Settings /> }),
  ];
}

function NotFound() {
  return <Route key={404} path="*" element={<PageNotFound />} />;
}

export function ApplicationRoutes() {
  return [DefaultRoute(), ...PublicRoutes(), ...PrivateRoutes(), NotFound()];
}
